export const ISAD_LEVELS = ["A", "B", "C", "D", "E"];

export const ISAD_CONFIG = Object.freeze({
  A: { color: "#2e7d32", label: "Full support" },
  B: { color: "#66bb6a", label: "Good" },
  C: { color: "#ffa726", label: "Marginal" },
  D: { color: "#ef6c00", label: "Limited" },
  E: { color: "#c62828", label: "Non-viable" },
});

export const NO_DATA_COLOR = "#9e9e9e";

export function getIsadColor(level) {
  return ISAD_CONFIG[level]?.color ?? NO_DATA_COLOR;
}
